namespace Solovis.Reports.Parameters.AssetCollection {

  export interface AssetCollectionOtherOptions {
    includeLockDates?: boolean;
    includeLiquidityModels?: boolean;
    useBookedValues?: boolean;
    includeAuditInfo?: boolean;
  }

  export class AssetCollectionOtherOptionsParameterControl extends Solovis.UI.BaseControl {

    private _otherOptions: AssetCollectionOtherOptions;
    private _parameterSet: ParameterSet;

    private _otherLabel;
    private _otherEditLink;

    constructor(options) {
      super(options);

      this._parameterSet = options.parameterList.parameterSet;
      this._otherOptions = (typeof options.initialValue != "undefined") ? options.initialValue : null;
    }


    public doRender() {
      let self = this;

      this._otherLabel = $("<a>").text("Other Options").appendTo(this.container);
      this._otherLabel.click(function () {
        self._showAssetCollectionOtherOptionsEditor();
      });

      this._otherEditLink = $("<a>").appendTo(this.container)
        .css("padding-left", "5px")
        .html("<span class='fa fa-pencil'></span>");
      this._otherEditLink.click(function () {
        self._showAssetCollectionOtherOptionsEditor();
      });
    }


    private _showAssetCollectionOtherOptionsEditor() {
      let editorDialog = new AssetCollectionOtherOptionsEditorDialog({
        otherOptions: this._otherOptions,
        parameterSet: this._parameterSet,
        saveCallback: (newOtherOptions) => {
          this.setParameterValue(newOtherOptions);
        }
      });

      editorDialog.show();
    }


    public _setCurrentOtherOptions(newOtherOptions) {
      this._otherOptions = newOtherOptions;
    }

    public setParameterValue(newValue, more?) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this, AssetCollectionOtherOptionsParameterControl, this._setCurrentOtherOptions, newValue, more);
    }

    public getParameterValue() {
      return Solovis.deepCopy(this._otherOptions);
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }
  }

  export class AssetCollectionOtherOptionsEditorDialog {

    private _otherOptions: AssetCollectionOtherOptions;
    private _parameterSet: ParameterSet;
    private _saveCallback;

    private _formBuilder: Solovis.UI.InputControls.FormBuilder;

    public constructor(options) {
      this._otherOptions = options.otherOptions ? options.otherOptions : {};
      this._parameterSet = options.parameterSet;
      this._saveCallback = options.saveCallback;
    }

    public show() {
      let otherOptions = this._otherOptions;
      let self = this;

      let formBuilderDiv = $("<div>");
      let formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formBuilderDiv,
        width: 800,
        labelColumnWidth: 245
      });
      this._formBuilder = formBuilder;

      formBuilder.addEntry({
        name: "includeLockDates",
        label: "Include Lock Dates",

        help: "If enabled, lock dates for live and book values will be shown for each asset.",

        initialValue: otherOptions.includeLockDates ? true : false,

        editor: {
          type: "bool"
        }
      });

      formBuilder.addEntry({
        name: "includeLiquidityModels",
        label: "Include Liquidity Models",

        help: "If enabled, the associated Liquidity Model will be shown for each asset.",

        initialValue: otherOptions.includeLiquidityModels ?? false,

        editor: {
          type: "bool"
        }
      });

      formBuilder.addEntry({
        name: "useBookedValues",
        label: "Use Booked Values",
        initialValue: otherOptions.useBookedValues ?? false,
        isVisible: function (): boolean {
          return self._parameterSet.getParameterValue("includeMarketValues");
        },
        editor: {
          type: "bool"
        }
      });

      formBuilder.addEntry({
        name: "includeAuditInfo",
        label: "Include Audit Info",

        help: "If enabled, the report displays the audit information of the user who last updated the asset and the date it was last updated.",

        initialValue: otherOptions.includeAuditInfo ?? false,

        editor: {
          type: "bool"
        }
      });

      formBuilder.setupDone();

      formBuilder.showAsDialog({
        title: "Edit Other Options",

        desiredWidth: 600,
        desiredHeight: 600,

        showSaveCancel: true,
        saveButtonText: "OK",

        saveCallback: () => {
          let newOptions = this._getNewOtherOptions();

          this._saveCallback(newOptions);

          return true;
        }
      });
    }

    private _getNewOtherOptions() {
      let newOtherOptions: AssetCollectionOtherOptions = {};

      let includeLockDates = this._formBuilder.getValueByName("includeLockDates");
      if (includeLockDates) {
        newOtherOptions.includeLockDates = true;
      }

      let includeLiquidityModels = this._formBuilder.getValueByName("includeLiquidityModels");
      if (includeLiquidityModels) {
        newOtherOptions.includeLiquidityModels = true;
      }

      newOtherOptions.includeAuditInfo = this._formBuilder.getValueByName("includeAuditInfo") ?? false;     

      newOtherOptions.useBookedValues = this._formBuilder.getValueByName("useBookedValues");

      return newOtherOptions;
    }
  }
}
